/**
 * Two-tab toggle that flips a card between "money raised" and "minutes
 * read" views. Used by the school admin dashboard's top-students /
 * top-classrooms cards and the teacher dashboard's classroom leaderboard
 * so the same affordance shows up everywhere a list can be ranked by
 * either metric.
 */
export default function ModeToggle({ isMoney, onMoney, onMinutes }) {
  return (
    <div className="inline-flex rounded-lg border border-border bg-secondary/30 p-0.5 shrink-0" role="tablist">
      <ModeTab active={isMoney} onClick={onMoney} aria-label="Rank by money raised">
        Raised
      </ModeTab>
      <ModeTab active={!isMoney} onClick={onMinutes} aria-label="Rank by minutes read">
        Minutes
      </ModeTab>
    </div>
  );
}

function ModeTab({ active, onClick, children, ...props }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={`inline-flex items-center justify-center min-h-8 px-3 py-1 text-xs font-semibold rounded-md transition-colors ${
        active
          ? "bg-card text-foreground shadow-sm"
          : "text-muted-foreground hover:text-foreground"
      }`}
      {...props}
    >
      {children}
    </button>
  );
}
